import { LoadingStatusType } from "@/enums/enums";
import { AddPackageCache, GetPackageFromCache } from "@/helper/cacheHelper";
import { MerchantId } from "@/helper/userHelper";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Package extends VuexModule {
  private packageDetail: any | null = null;
  private packageDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getPackageDetail(): any {
    return this.packageDetail;
  }

  get getPackageDetailLoadingStatus(): LoadingStatusType {
    return this.packageDetailLoadingStatus;
  }

  @Mutation
  public SetPackageDetail(packageDetail: any) {
    this.packageDetail = packageDetail;
  }

  @Mutation
  public SetPackageDetailLoadingStatus(status: LoadingStatusType) {
    this.packageDetailLoadingStatus = status;
  }

  @Action
  public async DoGetPackageDetail() {
    if (this.packageDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPackageDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });

      const packageDetailCache = await GetPackageFromCache(MerchantId());

      if (packageDetailCache) {
        this.context.commit("SetPackageDetail", packageDetailCache);
        this.context.commit("SetPackageDetailLoadingStatus", LoadingStatusType.Success);

        this.context.dispatch("Loading/IsLoading", false, { root: true });
      } else {
        API.PackageService.DoGetPackageDetail().then(async (res: any) => {
          if (res.data.responseCode.IsSuccess()) {
            const packageDetail = res.data.package;
            await AddPackageCache(MerchantId(), packageDetail);
            this.context.commit("SetPackageDetail", packageDetail);
          }
          this.context.commit("SetPackageDetailLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        });
      }
    }
  }
}
